import { makeStyles } from '@material-ui/core/styles';
import logo from '@resources/icons/svg/logoSmall.svg';
import logoVc from '@resources/icons/svg/logoSmallVc.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    boxShadow: '6px 0px 18px rgba(0, 0, 0, 0.06)',
    cursor: 'pointer',
  },
  img: {
    display: 'block',
  },
}));

const LogoSmall = ({ onClick }) => {
  const classes = useStyles();

  return (
    <div className={ classes.root } onClick={ onClick }>
      <img className={ classes.img } src={ process.env.REACT_APP_BRAND ? logoVc : logo } alt="logo" />
    </div>
  );
};

export default LogoSmall;
